import { render, staticRenderFns } from "./newupload.vue?vue&type=template&id=19a370b9&scoped=true"
import script from "./newupload.vue?vue&type=script&lang=js"
export * from "./newupload.vue?vue&type=script&lang=js"
import style0 from "./newupload.vue?vue&type=style&index=0&id=19a370b9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a370b9",
  null
  
)

export default component.exports